import { SpanStatusCode, trace } from '@opentelemetry/api'

const TRACER_NAME = 'arvore-frontend'

const serializeContext = (context: unknown): string => {
  try {
    return JSON.stringify(context)
  } catch {
    return String(context)
  }
}

export const recordErrorSpan = (error: unknown, context?: unknown): void => {
  const span = trace.getTracer(TRACER_NAME).startSpan('app.error')
  const exception = error instanceof Error ? error : new Error(String(error))
  span.recordException(exception)
  span.setStatus({ code: SpanStatusCode.ERROR, message: exception.message })
  if (context !== undefined) {
    span.setAttribute('app.error.context', serializeContext(context))
  }
  span.end()
}
